import { render, staticRenderFns } from "./add-market-modal.vue?vue&type=template&id=60846083&scoped=true&"
import script from "./add-market-modal.vue?vue&type=script&lang=js&"
export * from "./add-market-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-market-modal.vue?vue&type=style&index=0&id=60846083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60846083",
  null
  
)

export default component.exports